import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { SupportAccessModel } from '@models/support-access.model';

import { SupportAccessActions } from './support-access.action-types';

export interface SupportAccessState extends EntityState<SupportAccessModel.Document> {
  isLoading: boolean;
  isCreating: boolean;
  isUpdating: boolean;
}

export const adapter: EntityAdapter<SupportAccessModel.Document> = createEntityAdapter<SupportAccessModel.Document>({
  selectId: (document: SupportAccessModel.Document) => document._id,
});

const initialState: SupportAccessState = adapter.getInitialState({
  isLoading: false,
  isCreating: false,
  isUpdating: false,
});

export const supportAccessStateReducer = createReducer(
  initialState,
  on(SupportAccessActions.resetToInitialState, () => ({
    ...initialState,
  })),
  on(SupportAccessActions.getSupportAccess, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(SupportAccessActions.getSupportAccessSuccess, (state, { documents }) => (
    adapter.setAll(documents, {
      ...state,
      isLoading: false,
    })
  )),
  on(SupportAccessActions.getSupportAccessFail, (state) => ({
    ...state,
    isLoading: false,
  })),
  on(SupportAccessActions.getAllSupportAccess, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(SupportAccessActions.getAllSupportAccessSuccess, (state, { documents }) => (
    adapter.setAll(documents, {
      ...state,
      isLoading: false,
    })
  )),
  on(SupportAccessActions.getAllSupportAccessFail, (state) => ({
    ...state,
    isLoading: false,
  })),
  on(SupportAccessActions.createSupportAccess, (state) => ({
    ...state,
    isCreating: true,
  })),
  on(SupportAccessActions.createSupportAccessSuccess, (state) => ({
    ...state,
    isCreating: false,
  })),
  on(SupportAccessActions.createSupportAccessFail, (state) => ({
    ...state,
    isCreating: false,
  })),
  on(SupportAccessActions.updateSupportAccess, (state) => ({
    ...state,
    isUpdating: true,
  })),
  on(SupportAccessActions.updateSupportAccessSuccess, (state, { document }) =>
    adapter.updateOne(
      {
        id: document._id,
        changes: document,
      },
      {
        ...state,
        isUpdating: false,
      },
    ),
  ),
  on(SupportAccessActions.updateSupportAccessFail, (state) => ({
    ...state,
    isUpdating: false,
  })),
  on(SupportAccessActions.updateSupportAccessEnabledSuccess, (state, { document }) => (
    adapter.updateOne({
      id: document._id,
      changes: document,
    }, state)
  )),
  on(SupportAccessActions.deleteSupportAccessSuccess, (state, { id }) => adapter.removeOne(id, state)),
  on(SupportAccessActions.updateSupportAccessStore, (state, { id, document }) => (
    adapter.updateOne({
      id,
      changes: document,
    }, state)
  )),
);
